module.exports = __webpack_public_path__ + "media/wood_6.1fcc987d.mp3";